import { connect } from 'react-redux'
import { resetConfiguratorWizard, resetStockWizard } from 'core/components/wizard/actions'
import { resetConfigurator } from '../configurator/actions'
import { resetTradeIn } from '../trade-in/actions'
import { resetStock } from '../stock/actions'
import { resetTradeInContext } from '../configuration/actions'

import Home from './Home'

//const mapStateToProps = state => ({})

const mapDispatchToProps = {
  resetConfigurator,
  resetConfiguratorWizard,
  resetStock,
  resetStockWizard,
  resetTradeInContext,

  resetTradeIn
}

export default connect(null, mapDispatchToProps)(Home)
